import { CompanyApiClient } from '@/clients/companyApiClient';
import { Company, CompanyOverview } from '@/types/company';

export class CompanyService {
  async getCompany(): Promise<Company> {
    return CompanyApiClient.getCompany();
  }

  async getAllCompanies(): Promise<CompanyOverview[]> {
    return CompanyApiClient.getAllCompanies();
  }

  async switchCompany(companyId: string | null): Promise<boolean> {
    return CompanyApiClient.switchCompany(companyId);
  }
} 